import React from 'react'
import { NavLink } from 'react-router-dom'
import buttonStyles from '../../../../../../../components/Button/Button.module.scss'

export const UninstalledAiFeature = () => {
  return (
    <div className='no-result-container p-3 '>
      <NavLink
        className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium d-inline-flex pe-1`}
        to='/workspace/setup/preset'
        target='_blank'
      >
        Install
      </NavLink>
      <span className='paragraph-medium'>this preset to be able to get results for it.</span>
    </div>
  )
}
